//                                                    
import { repo } from '@bi/sync';
export const GroupsRepository = repo.rbac.GroupsRepository;
export const ExtGroupsRepository = repo.rbac.ExtGroupsRepository;
export const ExtDomainsRepository = repo.rbac.ExtDomainsRepository;
export const RulesRepository = repo.rbac.RulesRepository;
export const DomainGroupKoobFiltersRepository = repo.rbac.DomainGroupKoobFiltersRepository;
